<template>
  <f7-page id="inbox"
    class="page-on-center rowBackgroundHomepage"
    data-page="inbox-page"
    :pull-to-refresh="isSmartphoneOS" @ptr:refresh="onRefresh(false)"
    infinite-scroll @infinite="onInfinite">

    <div v-if="isSmartphoneOS" slot="fixed">
      <div style="position:absolute;top:44px;width:100%;">
        <cm-messages-filter
          v-if="serviceId === services.DOCUMENTSERVICE && !sharedFoldersConfig"
          class="researchfilter"
          style="position:relative;z-index:10"
          isPayments received
          filterType="details"
          :mode="this.mode"
          @applyFilter="applyFilter($event)">
        </cm-messages-filter>
        <cm-messages-filter
          v-else-if="serviceId === services.DIRECTPAYMENTS && mode === 0"
          class="researchfilter"
          style="position:relative;z-index:10"
          isPayments received
          filterType="draft"
          :mode="this.mode"
          @applyFilter="applyFilter($event)">
        </cm-messages-filter>
        <cm-messages-filter
          v-else-if="serviceId === services.PAYMENTS && mode === 2"
          class="researchfilter"
          style="position:relative;z-index:10"
          isPayments received
          filterType="group"
          :mode="this.mode"
          @applyFilter="applyFilter($event)">
        </cm-messages-filter>
        <cm-messages-filter
          v-else
          class="researchfilter"
          style="position:relative;z-index:10"
          isPayments received
          filterType="list"
          :mode="this.mode"
          @applyFilter="applyFilter($event)">
        </cm-messages-filter>
      </div>
    </div>

    <div class="layoutTop" v-if="!isSmartphoneOS"></div>

    <div class="listPage" style="overflow:hidden;">
      <b-row class="form-group justify-content-start showLargeScreenOnly">
        <!-- csv extraction to do asap -->
        <!-- <extract-csv-button @startCSVextraction="extractCSV(inboxMessages)"></extract-csv-button> -->
        <b-col sm="2">
          <f7-button class="button-action milkyBlockBlack" :disabled="activateSpinner"
            @click="refreshInbox()">
            <f7-icon f7="refresh"></f7-icon>
            <span class="fab-label">{{ $t('common.rfrsh') }}</span>
          </f7-button>
        </b-col>
        <b-col sm="2" v-if="serviceId === services.SUPPLIERS">
          <f7-button class="button-action milkyBlockBlack"
            href="/suppliers/create/">
            <f7-icon f7="add"></f7-icon>
            <span>{{ $t('common.add_label') }}</span>
          </f7-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <div class="requestsList">
            <div v-if="!isSmartphoneOS">
              <cm-messages-filter
                v-if="serviceId === services.DOCUMENTSERVICE && !sharedFoldersConfig"
                class="researchfilter"
                style="position:relative;z-index:10"
                isPayments received
                filterType="details"
                :mode="this.mode"
                @applyFilter="applyFilter($event)">
              </cm-messages-filter>
              <cm-messages-filter
                v-else-if="serviceId === services.DIRECTPAYMENTS && mode === 0"
                class="researchfilter"
                style="position:relative;z-index:10"
                isPayments received
                filterType="draft"
                :mode="this.mode"
                :randomId="randomId"
                @applyFilter="applyFilter($event)">
              </cm-messages-filter>
              <cm-messages-filter
                v-else-if="serviceId === services.PAYMENTS && mode === 2"
                class="researchfilter"
                style="position:relative;z-index:10"
                isPayments received
                filterType="group"
                :mode="this.mode"
                :randomId="randomId"
                @applyFilter="applyFilter($event)">
              </cm-messages-filter>
              <cm-messages-filter
                v-else
                class="researchfilter"
                style="position:relative;z-index:10"
                isPayments received
                filterType="list"
                :mode="this.mode"
                :randomId="randomId"
                @applyFilter="applyFilter($event)">
              </cm-messages-filter>
            </div>
            <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
            <div style="margin-top:0">
              <spinner v-if="activateSpinner || activateSpinnerDraft || activateSpinnerGroup"></spinner>
              <dp-draft-list
                v-else-if="serviceId === services.DIRECTPAYMENTS && mode === 0"
                :drafts="inboxDraft">
              </dp-draft-list>
              <documents-list
                v-else-if="serviceId === services.DOCUMENTSERVICE && mode === 1 && !sharedFoldersConfig"
                :documents="inboxMessages">
              </documents-list>
              <suppliers-list
                v-else-if="serviceId === services.SUPPLIERS && mode === 1"
                :sellers="inboxMessages">
              </suppliers-list>
              <document-to-validate-list
                v-else-if="serviceId === services.DOCUMENTSERVICE && mode === 2"
                :documents="inboxMessages">
              </document-to-validate-list>
              <transactions-list v-else
                :filterBy="filterBy"
                :messages="inboxMessages"
                :randomId="randomId"
                :serviceId="serviceId">
              </transactions-list>
            </div>
          </div>

          <!-- <cm-pagination
            v-if="mode === 0"
            :firstIndex="paginationObjectDraft.firstIndex"
            :maxResultsByPage="paginationObjectDraft.maxResults"
            :nbResultsTotal="paginationObjectDraft.nbResultsTotal"
            :refreshEvent="paginationObjectDraft.refresh">
          </cm-pagination>
          <cm-pagination
            v-else-if="mode === 2"
            :firstIndex="paginationObjectGroup.firstIndex"
            :maxResultsByPage="paginationObjectGroup.maxResults"
            :nbResultsTotal="paginationObjectGroup.nbResultsTotal"
            :refreshEvent="paginationObjectGroup.refresh">
          </cm-pagination>
          <cm-pagination
            v-else
            :firstIndex="paginationObject.firstIndex"
            :maxResultsByPage="paginationObject.maxResults"
            :nbResultsTotal="paginationObject.nbResultsTotal"
            :refreshEvent="paginationObject.refresh">
          </cm-pagination> -->
        </b-col>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import moment from 'moment'

import DocumentsList from '@/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentList.vue'
import DocumentToValidateList from '@/pages/requests/detailPages/supplierDetailPages/DocumentToValidateList.vue'
import DPDraftList from '@/pages/services/directPayments/DPDraftList.vue'
import SuppliersList from '@/pages/requests/SuppliersList.vue'
import TransactionsList from '@/pages/requests/TransactionsList.vue'

import ExtractCSVbutton from '@/components/common/extractCSVbutton.vue'
import MessagesFilter from '@/components/common/Filter'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'

import documentSerialize from '@/helpers/documentSerialize.json'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import services from '@/helpers/services'
import {statusLabel} from '@/helpers/labels'

export default {
  name: 'Inbox',
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': Pagination,
    'documents-list': DocumentsList,
    'document-to-validate-list': DocumentToValidateList,
    'dp-draft-list': DPDraftList,
    'extract-csv-button': ExtractCSVbutton,
    'spinner': Spinner,
    'suppliers-list': SuppliersList,
    'transactions-list': TransactionsList
  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    customMobileLayoutStyle () {
      if (this.serviceId === services.PAYMENTS) {
        return 'height:136px;'
      } else {
        return 'height:90px;'
      }
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      let fromServiceIdToLabel = {
        0: {
          '6': this.$t('Webheader.my_drafts')
        },
        1: {
          '1': this.$t('Webheader.my_claims'),
          '2': this.$t('Webheader.my_modular_loans'),
          '6': this.$t('Webheader.my_transfers'),
          '7': this.$t('Webheader.my_business_folders'),
          '8': this.$t('Webheader.my_suppliers')
        },
        2: {
          '1': this.$t('Webheader.my_claims_folders'),
          '7': this.$t('Webheader.my_business_documents_to_validate')
        }
      }
      return fromServiceIdToLabel[this.modeFilter][this.$engine.user.currentService.id]
    }
  },
  data () {
    return {
      activateSpinner: false,
      activateSpinnerDraft: false,
      activateSpinnerGroup: false,
      filterBy: '',
      fromIdToServiceName: {
        '1': 'payments',
        '2': 'directDebit',
        '6': 'directPayments',
        '7': 'businessDocuments',
        '8': 'suppliers'
      },
      inboxDraft: [],
      inboxMessages: [],
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollDown: false,
      scrollFlag: true,
      serviceId: this.$engine.user.currentService.id.toString(),
      serviceName: this.$t('common.appname'),
      services: services,
      sharedFoldersConfig: this.$engine.services.businessDocuments.sharedFoldersConfig
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.listTitle,
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0

    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$engine.settings.set({msgDirection: this.direction})
    this.$engine.services.payments.currentSendbox = {}

    this.$bus.$off('refresh-cache-contacts')
    if (this.serviceId === services.PAYMENTS) {
      this.paginationObject['refresh'] = 'inbox-filtered'
      this.$bus.$off('inbox-filtered')
      this.$bus.$off('refresh-inbox-on-seen')
      this.$bus.on('refresh-inbox-on-seen', (refPays) => {
        that.updateInbox(refPays, true)
        loadPage(that, {url: '/payments/transaction-details/'})
      })
      this.$bus.$on('inbox-filtered', index => {
        that.onRefresh(false, index)
        that.pageCounter = 0
      })
    } else if (this.serviceId === services.DIRECTDEBIT) {
      this.paginationObject['refresh'] = 'direct-debit-filtered'
      this.$bus.$off('direct-debit-filtered')
      this.$bus.$on('direct-debit-filtered', index => {
        that.onRefresh(false, index)
        that.pageCounter = 0
      })
    } else {
      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.$bus.$off('direct-inbox-filtered')
      this.$bus.$on('direct-inbox-filtered', index => {
        this.onRefresh(false, index)
        that.pageCounter = 0
      })
    }

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.services.getServiceIdByName(val)
    })
  },
  beforeDestroy () {
    let that = this
    if (that.serviceId !== services.SUPPLIERS) {
      that.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.cleanFilterCondition()
    }
  },
  methods: {
    applyFilter (filterConditions) {
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      if (this.mode === 0) {
        if (this.serviceId === services.DIRECTPAYMENTS) {
          this.activateSpinnerDraft = true
          this.updateInbox({})
          this.$bus.emit('refresh-cache-paging-template', {})
          this.getDPDraft(filterConditions)
        }
      } else if (this.mode === 2) {
        if (this.serviceId === services.PAYMENTS) {
          this.activateSpinnerGroup = true
          this.updateInbox({})
          this.$bus.emit('refresh-cache-paging-template', {})
          this.getRTPGroup(filterConditions)
        }
      } else {
        this.activateSpinner = true
        this.$engine.services[this.fromIdToServiceName[this.serviceId]].update(
          this.direction,
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        ).then(resp => {
          let requests = {}
          switch (this.serviceId) {
            case services.PAYMENTS:
              this.paginationObject.nbResultsTotal = resp.data.totalPayments
              this.paginationObject.nbResults = resp.data.payments.length
              requests = resp.data.payments
              break
            case services.DIRECTDEBIT:
              this.paginationObject.nbResultsTotal = resp.data.totalDirectDebits
              this.paginationObject.nbResults = resp.data.directDebits.length
              requests = resp.data.directDebits
              break
            case services.DIRECTPAYMENTS:
              this.paginationObject.nbResultsTotal = resp.data.totalDirectPayments
              this.paginationObject.nbResults = resp.data.directPayments.length
              requests = resp.data.directPayments
              break
            case services.DOCUMENTSERVICE:
              if (this.sharedFoldersConfig) {
                this.paginationObject.nbResults = resp.data.groups.length
                requests = resp.data.groups
              } else {
                this.paginationObject.nbResults = resp.data.Documents.length
                requests = resp.data.Documents
              }
              break
            case services.SUPPLIERS:
              this.paginationObject.nbResults = resp.data.Sellers.length
              requests = resp.data.Sellers
              break
            default:
              break
          }
          this.updateInbox(requests)
          this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
          this.activateSpinner = false
        })
        .catch(error => {
          errorMessageAlert(error, this, this.$i18n)
        })
      }
    },
    attachInfinit () {
      if ((this.$settings.inboxPreloaderRemoved && this.serviceId === services.PAYMENTS) ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        if (this.serviceId === services.PAYMENTS) {
          this.$engine.settings.set({inboxPreloaderRemoved: false})
        } else {
          this.$engine.settings.set({sendboxPreloaderRemoved: false})
        }
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      if (this.serviceId === services.PAYMENTS) {
        this.$engine.settings.set({inboxPreloaderRemoved: true})
      } else {
        this.$engine.settings.set({sendboxPreloaderRemoved: true})
      }
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    extractCSV (inboxMessages) {
      if (this.serviceId === services.DOCUMENTSERVICE || this.serviceId === services.SUPPLIERS) {
        let that = this
        this.$f7.showPreloader(that.$i18n.t('common.loading_page_label'))
        this.$engine.services.businessDocuments.extractDataCsv({
        }).then(response => {
          let datas = response.data.split('\n')
          let firstLine = that.$i18n.t('businessDocuments.folder_reference') + ';' +
            that.$i18n.t('businessDocuments.folder_status') + ';' +
            that.$i18n.t('businessDocuments.folder_creationDate') + ';' +
            that.$i18n.t('businessDocuments.document_name') + ';' +
            that.$i18n.t('businessDocuments.document_correspondent') + ';' +
            that.$i18n.t('businessDocuments.other_info') + ';' +
            that.$i18n.t('businessDocuments.document_type') + ';' +
            that.$i18n.t('businessDocuments.document_status') + ';' +
            that.$i18n.t('businessDocuments.document_isNego') + ';' +
            that.$i18n.t('businessDocuments.document_role') + ';' +
            that.$i18n.t('businessDocuments.document_lastUpdate') + ';' +
            that.$i18n.t('businessDocuments.doc_details') + ';' +
            that.$i18n.t('businessDocuments.creation_date') + '\r\n'
          let lines = ''
          for (var i = 0; i < datas.length - 1; i++) {
            let elements = datas[i].split(';')
            let detailsDoc = ''
            let jsonStr = '{' + elements[11] + '}'
            let jsonParsed = JSON.parse(jsonStr)
            if (jsonParsed.serialize) {
              let keys = Object.keys(jsonParsed.serialize)
              detailsDoc = '"'
              for (var j = 0; j < keys.length; j++) {
                let key = keys[j]
                detailsDoc += that.$i18n.t('businessDocuments.serialize.' + elements[6] + '.' + key)
                detailsDoc += ' : '
                detailsDoc += jsonParsed.serialize[key]
                if (j !== keys.length - 1) {
                  detailsDoc += '\n'
                }
              }
              detailsDoc += '"'
            }
            lines += elements[0] + ';' +
                     statusLabel(that.$i18n, 'Folder_' + elements[1]) + ';' +
                     elements[2] + ';' +
                     elements[3] + ';' +
                     elements[4] + ';' +
                     elements[5] + ';' +
                     that.$i18n.t(documentSerialize[elements[6]].label) + ';' +
                     statusLabel(that.$i18n, 'Doc_' + elements[7], elements[9]) + ';' +
                     ((elements[8] === '0') ? that.$i18n.t('common.no_label') : that.$i18n.t('common.yes_label')) + ';' +
                     elements[9] + ';' +
                     elements[10] + ';' +
                     detailsDoc + ';' +
                     elements[12] + '\r\n'
          }
          let data = firstLine + lines
          that.$f7.hidePreloader()
          let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
          let downloadLink = document.createElement('a')
          let today = moment()
          let fileName = 'received' + this.fromIdToServiceName[this.serviceId] + today.unix() + '.csv'

          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }).catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        let firstLine = this.$t('common.status.status_label') + ';' +
          this.$t('common.rsn') + ';' + this.$t('common.total_amount_no_currency') + ';' +
          this.$t('attachments.id') + ';' + this.$t('common.dest_name') + ';' +
          this.$t('common.date_label') + ' \r\n'

        if (this.serviceId === services.DOCUMENTSERVICE) {
          firstLine = this.$t('common.status.status_label') + ';' +
          this.$t('businessDocuments.shared_folder_name') + ';' +
          this.$t('businessDocuments.document_to_treat_nb') + ';' +
          this.$t('businessDocuments.document_total_nb') + ';' +
          this.$t('common.dest_name') + ';' + this.$t('common.sender_label_singular') + '\r\n'
        }
        let lines = ''
        const that = this

        // this.scrollFlag = true
        this.$f7.showPreloader(that.$i18n.t('common.loading_page_label'))
        if (this.mode === 0) {
          if (this.serviceId === services.DIRECTPAYMENTS) {
            this.updateInbox({})
            this.$bus.emit('refresh-cache-paging-template', {})
            let filterConditions
            if (this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDraft.getDefaultFilter()) {
              filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDraft.getDefaultFilter()
            } else {
              filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDraft.getConditionObject()
            }
            this.getDPDraft(filterConditions)
          }
        } else if (this.mode === 2) {
          if (this.serviceId === services.PAYMENTS) {
            this.updateInbox({})
            this.$bus.emit('refresh-cache-paging-template', {})
            let filterConditions
            if (this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterGroup.getDefaultFilter()) {
              filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterGroup.getDefaultFilter()
            } else {
              filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterGroup.getConditionObject()
            }
            this.getRTPGroup(filterConditions)
          }
        } else {
          this.paginationObject['firstIndex'] = 1
          let filterConditions
          if (this.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.getDefaultFilter()) {
            filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.getDefaultFilter()
          } else {
            filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.getConditionObject()
          }
          this.$engine.services[this.fromIdToServiceName[this.serviceId]].update(
            this.direction,
            this.paginationObject.nbResultsTotal,
            this.paginationObject.firstIndex,
            filterConditions
          ).then(resp => {
            let inboxMessagesCSV = {}
            switch (this.serviceId) {
              case services.PAYMENTS:
                inboxMessagesCSV = resp.data.payments
                break
              case services.DIRECTDEBIT:
                inboxMessagesCSV = resp.data.directDebits
                break
              case services.DIRECTPAYMENTS:
                inboxMessagesCSV = resp.data.directPayments
                break
              case services.DOCUMENTSERVICE:
                if (this.sharedFoldersConfig) {
                  inboxMessagesCSV = resp.data.groups
                } else {
                  inboxMessagesCSV = resp.data.Documents
                }
                break
              case services.SUPPLIERS:
                inboxMessagesCSV = resp.data.Sellers
                break
              default:
                break
            }

            if (this.serviceId === services.DOCUMENTSERVICE) {
              for (let datas in inboxMessagesCSV) {
                lines += statusLabel(this.$i18n, 'Folder_' + inboxMessagesCSV[datas]['status']) + ';' +
                inboxMessagesCSV[datas]['reference'] + ';' +
                inboxMessagesCSV[datas]['nb_docs_to_process'] + ';' +
                inboxMessagesCSV[datas]['nb_docs_total'] + ';' +
                inboxMessagesCSV[datas]['correspondent'] + ';' +
                this.$engine.user.get().identifier + '\r\n'
              }
            } else {
              for (let datas in inboxMessagesCSV) {
                lines += statusLabel(this.$i18n, inboxMessagesCSV[datas]['status'], inboxMessagesCSV[datas]['negotStatus'], 0) + ';' +
                inboxMessagesCSV[datas]['reason'] + ';' +
                (inboxMessagesCSV[datas]['amount'] ? inboxMessagesCSV[datas]['amount'] : inboxMessagesCSV[datas]['amountResponse']) + ';' +
                inboxMessagesCSV[datas]['attachmentId'] + ';' +
                inboxMessagesCSV[datas]['creditorName'] + ';' +
                inboxMessagesCSV[datas]['creationDate'] + '\r\n'
              }
            }

            let data = firstLine + lines
            that.$f7.hidePreloader()
            const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
            const downloadLink = document.createElement('a')
            let today = moment()
            const fileName = 'received' + this.fromIdToServiceName[this.serviceId] + today.unix() + '.csv'

            downloadLink.href = linkSource
            downloadLink.download = fileName
            downloadLink.click()
          })
          .catch(error => {
            errorMessageAlert(error, that, this.$i18n)
          })
        }
      }
    },
    getRTPGroup (filterConditions = {}) {
      let that = this
      this.$engine.services.payments.getGroups(filterConditions).then(response => {
        let groups = response.data.groups
        this.paginationObject.nbResultsTotal = groups.length
        this.updateInbox(groups)
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.$f7.hideIndicator()
        this.activateSpinnerGroup = false
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        this.activateSpinnerGroup = false
        errorMessageAlert(error, that)
      })
    },
    getDPDraft (filterConditions = {}) {
      let that = this
      var draftListOnPage = []
      var draftList = {}
      this.$engine.dpDrafts.getDrafts().then(response => {
        that.status = response.status
        var groups = []
        let nbElement = 0
        this.$engine.accounts.fetchGroup().then(resp => {
          if (response.status === 200) {
            this.paginationObject.nbResults = 0
            draftList = response.data.drafts
            for (var i in draftList) {
              if (draftList[i].draftName.toLowerCase().includes(this.filterBy.toLowerCase())) {
                nbElement++
                // console.log('paramètres de drafts')
                if (this.paginationObject.firstIndex <= nbElement && nbElement < (this.paginationObject.firstIndex + this.paginationObject.maxResults)) {
                  if ((draftList[i].isValidated === '0' || draftList[i].isValidated === '2') &&
                      (draftList[i].isComplete === '1')) {
                    /* TLV 01/2020
                      On vérifie si l'id team du draft correspond bien à l'id team de l'utilisateur.
                      On obtient un tableau avec 1 élément si l'utilisateur est dans la team du draft.
                      this.$engine.accounts.getMembersGroup() récupère toutes les teams et les groupes de chaque team de l'entreprise
                      (même celles dont l'utilisateur actuel n'est pas inclus) */
                    let teams = this.$engine.accounts.getMembersGroup().filter(team => { return team.id_team === draftList[i].idTeam })
                    // On récupère les groupes de la team du draft, si l'id team du brouillon fait partie des teams de l'utilisateur
                    if (teams.length === 1) {
                      let groups = teams[0].groups
                      /* On recherche le groupe commun à la team de l'utilisateur et la team du draft qui n'a pas déjà validé le brouillon
                        Si le draft a déjà été validé, alors l'idAccount ne vaut plus '' mais la valeur du compte l'ayant validé */
                      groups = groups.filter(group => draftList[i].validators.filter(vgroup => { return vgroup.idAccount === '' }).map(vgroup => { return vgroup.groupId }).includes(group.id_group))
                      // console.log(groups)
                      /* L'icône de validation n'est affichée que pour le groupe de level le plus faible
                        (Par ex. si les comptables peuvent valider mais pas les groupes en-dessous hiérarchiquement, alors seuls eux voient l'icône) */
                      let minLevelValue = Math.min.apply(Math, groups.map(function (g) { return g.level }))
                      // Pour chacun des groupes de validation trouvés dans le draft, on regarde si l'utilisateur actuel est dedans
                      groups.forEach(group => {
                        if (group.members.map(member => { return member.id_user_account }).includes(this.$engine.user.get().userAccountId.toString())) {
                          // On vérifie si l'icône "Validate Draft" s'affiche sur la liste de brouillons générale (pour le groupe le plus faible de droits pouvant valider uniquement)
                          if (parseInt(group.level) === minLevelValue) {
                            draftList[i].printValidateDraftIcon = true
                            // On vérifie si l'utilisateur peut valider le brouillon une fois qu'il aura cliqué dessus
                            draftList[i].isValidator = true
                            draftList[i].idGroup = group.id_group
                          }
                        }
                      })
                    }
                  }
                  if (this.validateDraft(draftList[i], filterConditions)) {
                    draftList[i].validatorsGroups = groups
                    this.paginationObject.nbResults++
                    draftListOnPage.push(draftList[i])
                    draftListOnPage.sort()
                  } else {
                    nbElement--
                  }
                }
              }
            }
            this.paginationObject.nbResultsTotal = nbElement
            this.updateInboxDraft(draftListOnPage)
            this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
            that.$f7.hideIndicator()
            this.$f7.pullToRefreshDone()
          }
          this.activateSpinnerDraft = false
        })
      })
      .catch(error => {
        this.activateSpinnerDraft = false
        errorMessageAlert(error, that)
      })
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0
        if (this.mode === 0) {
          if (this.serviceId === services.DIRECTPAYMENTS) {
            this.updateInbox({})
            this.$bus.emit('refresh-cache-paging-template', {})
            let filterConditions
            if (this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDraft.getDefaultFilter()) {
              filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDraft.getDefaultFilter()
            } else {
              filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDraft.getConditionObject()
            }
            this.getDPDraft(filterConditions)
          }
        } else if (this.mode === 2) {
          if (this.serviceId === services.PAYMENTS) {
            this.updateInbox({})
            this.$bus.emit('refresh-cache-paging-template', {})
            let filterConditions
            if (this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterGroup.getDefaultFilter()) {
              filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterGroup.getDefaultFilter()
            } else {
              filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterGroup.getConditionObject()
            }
            this.getDPDraft(filterConditions)
          }
        } else {
          let filterConditions
          if (this.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.getDefaultFilter()) {
            filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.getDefaultFilter()
          } else {
            filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.getConditionObject()
          }
          this.$engine.services[this.fromIdToServiceName[this.serviceId]].update(
            this.direction,
            this.paginationObject['maxResults'],
            this.paginationObject['firstIndex'],
            filterConditions
          ).then(resp => {
            let requests = {}
            switch (that.serviceId) {
              case services.PAYMENTS:
                that.requestsNumber = resp.data.totalPayments
                requests = resp.data.payments
                break
              case services.DIRECTDEBIT:
                that.requestsNumber = resp.data.totalDirectDebits
                requests = resp.data.directDebits
                break
              case services.DIRECTPAYMENTS:
                that.requestsNumber = resp.data.totalDirectPayments
                requests = resp.data.directPayments
                break
              case services.DOCUMENTSERVICE:
                if (that.sharedFoldersConfig) {
                  that.requestsNumber = resp.data.groups.length
                  requests = resp.data.groups
                } else {
                  that.requestsNumber = resp.data.Documents.length
                  requests = resp.data.Documents
                }
                break
              case services.SUPPLIERS:
                that.requestsNumber = resp.data.Sellers.length
                // requests = resp.data.Sellers
                break
              default:
                break
            }
            that.paginationObject.nbResults = that.requestsNumber

            if (requests.length > 0) {
              for (let i = 0; i < requests.length; i++) {
                that.inboxMessages.push(requests[i])
              }
              if (requests.length < this.paginationObject['maxResults']) {
                that.detachInfinit()
              }
            } else {
              that.detachInfinit()
            }
            that.scrollFlag = true
          })
          .catch(error => {
            errorMessageAlert(error, that, that.$i18n)
            that.scrollFlag = true
          })
        }
      }
    },
    onRefresh (noAttach = false, index = 1) {
      // const that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      if (this.mode === 0) {
        if (this.serviceId === services.DIRECTPAYMENTS) {
          this.activateSpinnerDraft = true
          this.updateInbox({})
          this.$bus.emit('refresh-cache-paging-template', {})
          let filterConditions
          if (this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDraft.getDefaultFilter()) {
            filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDraft.getDefaultFilter()
          } else {
            filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDraft.getConditionObject()
          }
          this.getDPDraft(filterConditions)
        }
      } else if (this.mode === 2 && this.serviceId !== services.DOCUMENTSERVICE) {
        if (this.serviceId === services.PAYMENTS) {
          this.activateSpinnerGroup = true
          this.updateInbox({})
          this.$bus.emit('refresh-cache-paging-template', {})
          let filterConditions
          if (this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterGroup.getDefaultFilter()) {
            filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterGroup.getDefaultFilter()
          } else {
            filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterGroup.getConditionObject()
          }
          this.getRTPGroup(filterConditions)
        }
      } else {
        this.activateSpinner = true
        let filterConditions
        if (this.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.getDefaultFilter()) {
          filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.getDefaultFilter()
          if (this.mode === 2) {
            if (this.serviceId === services.DOCUMENTSERVICE) {
              this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDetails.statusDocRejected = 1
              this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDetails.statusDocValidated = 1
              filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filterDetails.getConditionObject()
            }
          }
        } else {
          filterConditions = this.$engine.services[this.fromIdToServiceName[this.serviceId]].filter.getConditionObject()
        }
        if (this.serviceId === services.PAYMENTS &&
          this.$engine.services.payments.currentSendbox.IdGroup) {
          filterConditions.IdGroup = this.$engine.services.payments.currentSendbox.IdGroup
          this.$engine.services.payments.currentSendbox = {}
        }
        this.$engine.services[this.fromIdToServiceName[this.serviceId]].update(
          this.direction,
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        ).then(resp => {
          let requests = {}
          switch (this.serviceId) {
            case services.PAYMENTS:
              this.paginationObject.nbResultsTotal = resp.data.totalPayments
              this.paginationObject.nbResults = resp.data.payments.length
              requests = resp.data.payments
              break
            case services.DIRECTDEBIT:
              this.paginationObject.nbResultsTotal = resp.data.totalDirectDebits
              this.paginationObject.nbResults = resp.data.directDebits.length
              requests = resp.data.directDebits
              break
            case services.DIRECTPAYMENTS:
              this.paginationObject.nbResultsTotal = resp.data.totalDirectPayments
              this.paginationObject.nbResults = resp.data.directPayments.length
              requests = resp.data.directPayments
              break
            case services.DOCUMENTSERVICE:
              if (this.sharedFoldersConfig) {
                this.paginationObject.nbResults = resp.data.groups.length
                requests = resp.data.groups
              } else {
                this.paginationObject.nbResults = resp.data.Documents.length
                requests = resp.data.Documents
              }
              break
            case services.SUPPLIERS:
              // this.paginationObject.nbResultsTotal = resp.data.totalGroups
              this.paginationObject.nbResults = resp.data.Sellers.length
              requests = resp.data.Sellers
              break
            default:
              break
          }
          this.updateInbox(requests, noAttach)
          this.$f7.pullToRefreshDone()
          this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
          this.activateSpinner = false
        })
        .catch(error => {
          errorMessageAlert(error, this, this.$i18n)
        })
      }
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateInboxDraft (requests, noAttach = false) {
      this.inboxDraft = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    validateDraft (draft, filterConditions) {
      let conditionChecked = false
      if (filterConditions.statusDraftNeedCompleted && !conditionChecked) {
        conditionChecked = draft.isComplete !== '1'
      }
      if (filterConditions.statusDraftReadyToSend && !conditionChecked) {
        conditionChecked = draft.isComplete === '1' && draft.isValidated === '1'
      }
      if (filterConditions.statusDraftWaitingUpperValidation && !conditionChecked) {
        conditionChecked = draft.isComplete === '1' && draft.isValidated === '2' && !draft.isValidator
      }
      if (filterConditions.statusDraftWaitingValidation && !conditionChecked) {
        conditionChecked = draft.isComplete === '1' && (draft.isValidated === '0' || (draft.isValidated === '2' && draft.isValidator))
      }
      if (
        !filterConditions.statusDraftNeedCompleted &&
        !filterConditions.statusDraftReadyToSend &&
        !filterConditions.statusDraftWaitingUpperValidation &&
        !filterConditions.statusDraftWaitingValidation
      ) {
        conditionChecked = true
      }
      if (filterConditions.reason && conditionChecked) {
        conditionChecked = draft.draftName.toUpperCase().includes(filterConditions.reason.toUpperCase())
      }
      if (filterConditions.cdtrOrDbtrNm && conditionChecked) {
        conditionChecked = draft.CreditorName.toUpperCase().includes(filterConditions.cdtrOrDbtrNm.toUpperCase())
      }
      if (filterConditions.dateBegin && conditionChecked) {
        let dateBeginFilter = new Date(filterConditions.dateBegin)
        let dateBeginGet = new Date(draft.RequestedExecutionDate)
        conditionChecked = dateBeginGet >= dateBeginFilter
      }
      if (filterConditions.dateEnd && conditionChecked) {
        let dateEndFilter = new Date(filterConditions.dateEnd)
        let dateEndGet = new Date(draft.RequestedExecutionDate)
        conditionChecked = dateEndGet <= dateEndFilter
      }
      return conditionChecked
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// InboxPage.vue?3b8ad844